import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerReviewList = createAsyncThunk(
  "customerReviewList/getCustomerReviewList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/get_all_review`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerReviewSlice = createSlice({
  name: "customerReviewList",
  initialState: {
    loading: false,
    customerReviewData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerReviewList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerReviewList.fulfilled, (state, action) => {
        state.loading = false;
        state.customerReviewData = action.payload;
      })
      .addCase(getCustomerReviewList.rejected, (state, action) => {
        state.loading = false;
        state.customerReviewData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerReviewSlice.reducer;
